import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as liveActions from "../../../redux/actions/live";
// Styles
import "./view.css";

const LiveView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);
  const user = useSelector(state => state.authReducer.user);

  // Set consts and vars
  const page = "live";
  const itemNameSingular = "Directe";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [
    `title`,
    `subtitle`,
    `start_time`,
    `end_time`,
    `days_of_week`,
    `enabled`,
  ];
  const sorters = filters;
  const columns = [
    { 
      name: "title",
      header: {
        dataType: "string",
        placeholder: "Títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "subtitle",
      width: `300px`,
      header: {
        dataType: "string",
        placeholder: "Sub-títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "image_1",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge 1",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "image_2",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge 2",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "start_time",
      width: `150px`,
      header: {
        dataType: "string",
        placeholder: "Hora inici",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "end_time",
      width: `150px`,
      header: {
        dataType: "string",
        placeholder: "Hora final",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "days_of_week",
      width: `300px`,
      header: {
        dataType: "string",
        placeholder: "Dies disponibles",
        textAlign: "center",
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },    
    { 
      name: "enabled",
      width: `105px`,
      header: {
        dataType: "boolean",
        placeholder: "Habilitat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="live-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"title"}
          menuConfig={{
            buttonNew: { visible: !!user && user.grants.live },
            buttonEdit: { visible: !!user && user.grants.live },
            buttonDelete: { visible: !!user && user.grants.live },
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista de <b>REPRODUCCIÓ EN DIRECTE</b>",
            forceRefreshDataAtBegining: true,
          }}
          reducerName="liveReducer"
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={liveActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"live"}
        />
      </div>
    </MainLayout>
  );
};

export default LiveView;
